<div class="delete-container">
    <p>
        ¿Está  seguro de que desea eliminar la nota?
    </p>
  </div>
  <div class="overlay-footer">
    <qr-button [config]="buttonCancel" (click)="closeOverlay()"></qr-button>
    <qr-button [config]="buttonDelete" (click)="confirmProcess()"></qr-button>
  </div>
  